// Notification API — authenticated endpoints for the notifications center.
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

// ─── Types ──────────────────────────────────────────────────────────────────

export type NotificationType = 'trade' | 'referral_reward' | 'price_alert' | string;

export interface AppNotification {
  id: number;
  type: NotificationType;
  title: string;
  body: string | null;
  data: Record<string, unknown> | null;
  isRead: boolean;
  createdAt: string;
}

export interface GetNotificationsParams {
  limit?: number;
  offset?: number;
}

export interface GetNotificationsResponse {
  success: boolean;
  data: AppNotification[];
  unreadCount: number;
  pagination: { total: number; limit: number; offset: number };
}

export interface UnreadCountResponse {
  success: boolean;
  unreadCount: number;
}

// ─── API ────────────────────────────────────────────────────────────────────

export const notificationApi = {
  getNotifications: async (
    params: GetNotificationsParams = {}
  ): Promise<GetNotificationsResponse> => {
    const { data } = await axiosClient.get<GetNotificationsResponse>(
      API_ENDPOINTS.NOTIFICATIONS.LIST,
      { params: { limit: params.limit ?? 20, offset: params.offset ?? 0 } }
    );
    return data;
  },

  getUnreadCount: async (): Promise<number> => {
    const { data } = await axiosClient.get<UnreadCountResponse>(
      API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT
    );
    return data?.unreadCount ?? 0;
  },

  /** Mark specific notifications read, or all of the user's if `ids` is omitted. */
  markRead: async (ids?: number[]): Promise<number> => {
    const { data } = await axiosClient.post<{ success: boolean; updated: number }>(
      API_ENDPOINTS.NOTIFICATIONS.MARK_READ,
      ids && ids.length ? { ids } : {}
    );
    return data?.updated ?? 0;
  },
};
